import { RTW_HOURS_PER_WEEK_FIELD_LABEL } from './RtwServiceConstants';

export const RTW_REQUIRED_MESSAGE = 'This field is required.';
export const RTW_PHYSICAL_RESTRICTIONS_MIN = 3;
export const RTW_PHYSICAL_RESTRICTIONS_MIN_MESSAGE = 'Minimum 3 characters';

export type RtwFieldErrors = {
    physicalRestrictions?: string;
    primaryLanguage?: string;
    hourlyRate?: string;
    isUnionMember?: string;
    lightDutyLocation?: string;
    transitionHoursPerWeek?: string;
    workSchedulePreferences?: string;
};

export type RtwFieldValidationState = {
    physicalRestrictions: string;
    primaryLanguage: string;
    hourlyRate: string;
    isUnionMember: string;
    lightDutyLocation: string;
    requiresAlternateHoursEnabled: boolean;
    transitionHoursPerWeek: string;
    requiresAlternateScheduleEnabled: boolean;
    workSchedulePreferences: string;
};

const FIELD_LABELS: Record<keyof RtwFieldErrors, string> = {
    physicalRestrictions: 'Current Physical Restrictions',
    primaryLanguage: 'Primary Language',
    hourlyRate: 'Hourly Rate of Pay',
    isUnionMember: 'Union Membership',
    lightDutyLocation: 'Light Duty Location',
    transitionHoursPerWeek: RTW_HOURS_PER_WEEK_FIELD_LABEL,
    workSchedulePreferences: 'Work Schedule Preferences',
};

export function validateRtwFields(state: RtwFieldValidationState): RtwFieldErrors {
    const errors: RtwFieldErrors = {};
    const physicalRestrictions = state.physicalRestrictions?.trim() ?? '';

    if (!physicalRestrictions) {
        errors.physicalRestrictions = RTW_REQUIRED_MESSAGE;
    } else if (physicalRestrictions.length < RTW_PHYSICAL_RESTRICTIONS_MIN) {
        errors.physicalRestrictions = RTW_PHYSICAL_RESTRICTIONS_MIN_MESSAGE;
    }

    if (!state.primaryLanguage?.trim()) {
        errors.primaryLanguage = RTW_REQUIRED_MESSAGE;
    }

    if (!state.hourlyRate?.trim()) {
        errors.hourlyRate = RTW_REQUIRED_MESSAGE;
    }

    if (!state.isUnionMember) {
        errors.isUnionMember = RTW_REQUIRED_MESSAGE;
    }

    if (!state.lightDutyLocation) {
        errors.lightDutyLocation = RTW_REQUIRED_MESSAGE;
    }

    if (state.requiresAlternateHoursEnabled && !state.transitionHoursPerWeek?.trim()) {
        errors.transitionHoursPerWeek = RTW_REQUIRED_MESSAGE;
    }

    if (state.requiresAlternateScheduleEnabled && !state.workSchedulePreferences?.trim()) {
        errors.workSchedulePreferences = RTW_REQUIRED_MESSAGE;
    }

    return errors;
}

export function isRtwFormValid(errors: RtwFieldErrors): boolean {
    return Object.keys(errors).length === 0;
}

export function getRtwMissingFieldLabels(errors: RtwFieldErrors): string[] {
    return (Object.keys(errors) as Array<keyof RtwFieldErrors>).map((key) => FIELD_LABELS[key]);
}

export function getRtwValidationToastMessage(errors: RtwFieldErrors): string {
    const labels = getRtwMissingFieldLabels(errors);
    if (labels.length === 0) {
        return '';
    }
    return `Please complete the following required fields: ${labels.join(', ')}.`;
}
